module.exports = __webpack_public_path__ + "img/grand-palm-pool.e10b365a.jpg";